<script setup>
import { watch } from 'vue'
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const model = defineModel('model')
const active = defineModel('active')
const props = defineProps(['values', 'title'])
const types = ref(model.value)

const setModel = () => {
  model.value = types.value
  active.value = false
}

watch(model, () => {
  types.value = model.value
})
</script>

<template>
  <b-modal
    v-model="active"
    trap-focus
    :destroy-on-hide="false"
    aria-role="dialog"
    aria-label="Example Modal"
    close-button-aria-label="Close"
    aria-modal
    :can-cancel="['escape', 'outside']"
    class="is-left"
    id="modal-filters"
  >
    <template #default="modalProps">
      <header>
        <span class="is-size-6 is-uppercase">{{
          title || t('filters.types')
        }}</span>
        <button
          type="button"
          class="button is-light is-exit ml-auto"
          aria-label="close"
          @click="modalProps.close"
        >
          <b-icon icon="close"></b-icon>
        </button>
      </header>

      <main>
        <div class="field" v-for="item in values">
          <b-checkbox v-model="types" :native-value="item._id">
            <span>{{ item.name }}</span>
            <span class="ml-auto">{{ item.count }}</span>
          </b-checkbox>
        </div>
      </main>

      <footer>
        <div class="buttons">
          <button
            type="button"
            class="button is-rounded is-uppercase is-flex-grow-1"
            @click="modalProps.close"
          >
            {{ t('filters.cancel') }}
          </button>

          <button
            type="button"
            class="button is-black is-rounded is-uppercase is-flex-grow-1"
            @click="setModel"
          >
            {{ t('filters.apply') }}
          </button>
        </div>
      </footer>
    </template>
  </b-modal>
</template>
